<template>
  <div v-if="displayLink" class="multioffice-offers-list">
    <span v-for="offer in getList" :key="offer.id" class="multioffice-offers-list__name">
      <a :key="offer.id" :href="offer.url" target="_blank">{{ offer.name }}</a>
    </span>
  </div>
  <span v-else>
    {{ getOffersNameList }}
  </span>
</template>

<script>
import { dealMixin } from '@organisms/dealMixin';

export default {
  name: 'DealOffersNameList',
  mixins: [ dealMixin ],
  props: {
    deal: { type: Object, required: true },
    displayLink: { type: Boolean, default: false },
  },
  computed: {
    getList() {
      return this.deal.office_offers_collection.map((relation) => relation.office_offer);
    },
  },
};
</script>
